/**
 * The assistant request keeps the last 10 turns and caps each one.
 * The server applies the same cap. Sending the extra bytes does not
 * change the answer.
 */

const { sanitizeLabel } = require('./applianceLabel');

const CHAT_HISTORY_LIMIT = 10;
const CHAT_HISTORY_CHARS = 2000;

function chatHistoryPayload(messages) {
  const list = Array.isArray(messages) ? messages : [];
  const recent = list.slice(-CHAT_HISTORY_LIMIT);
  const payload = [];
  for (let index = 0; index < recent.length; index += 1) {
    const msg = recent[index];
    if (!msg || msg.error) continue;
    const content = String(msg.content || '').slice(0, CHAT_HISTORY_CHARS);
    if (!content) continue;
    const entry = {
      role: msg.role === 'assistant' ? 'assistant' : 'user',
      content,
    };
    const label = sanitizeLabel(msg.label);
    if (label) entry.label = label;
    payload.push(entry);
  }
  return payload;
}

module.exports = {
  CHAT_HISTORY_LIMIT,
  CHAT_HISTORY_CHARS,
  chatHistoryPayload,
};
